<template>
  <div class="user-form">
    <spinner v-if="isLoading" class="mt-5"></spinner>
    <UserForm
      v-else
      v-show="isFormReady"
      :user="this.user"
      data-cy="new-user-form"
      :validation-loading="validationLoading"
      @update-validation-loading="handleValidationLoading"
      @update-is-form-ready="setFormReady"
      @submit="saveUser"
    />
  </div>
</template>

<script>
import { mapGetters } from "vuex"
import UserForm from "@/components/users/UserForm.vue"

export default {
  name: "UsersNew",
  components: {
    UserForm,
  },
  data() {
    return {
      user: {
        first_name: "",
        last_name: "",
        email: "",
        group_ids: null,
        partner_id: null,
        company_id: null,
      },
      isLoading: true,
      isFormReady: false,
      validationLoading: false,
    }
  },
  computed: {
    ...mapGetters("users", ["errors"]),
  },
  methods: {
    async saveUser(payload) {
      await this.$store.dispatch("users/addUser", payload)

      if (!this.errors) {
        await this.$router.push({ name: "usersList" })
      }

      this.validationLoading = false
    },
    handleValidationLoading(boolean) {
      this.validationLoading = boolean
    },
    setFormReady() {
      this.isFormReady = true
    },
  },
  created() {
    this.isLoading = false
  },
}
</script>
